<h2 class="mat-dialog-title d-flex justify-content-between uppercase title">
  <span>{{ multilingualService.langMap?.LABEL_REGISTRATION_SAMPLE_CARD }}</span>
  <span class="close" (click)="close()">&#x2715;</span>
</h2>

<div class="content">
  <img pointer imageName="sample-id-card.svg" [common]="true" alt="ID Card" />
</div>
